import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import {
  FeedbackAndQuestionNoticeCreate,
  FeedbackAndQuestionNoticeResponse,
  feedbackAndQuestionNoticeResponseSchema,
} from '../../../common/validations/feedbackAndQuestionNotice'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { ResidentAppError } from '../../../common/error'
import { ErrorResponse } from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIPostFeedback = (
  options?: UseMutationOptions<
    FeedbackAndQuestionNoticeResponse,
    ErrorResponse,
    FeedbackAndQuestionNoticeCreate
  >
) => {
  const { isError, isPending, mutate } = useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.CREATE_FEEDBACK,
        data,
        feedbackAndQuestionNoticeResponseSchema
      ),
    retry: 1,
    throwOnError: false,
    ...options,
  })

  if (isError) {
    throw ResidentAppError.ClientError('FEEDBACK_SUBMIT_ERROR')
  }

  return {
    submit: mutate,
    isSubmitting: isPending,
  }
}
